/* SEROTA — generated from design-system/components/bundle.js by packages/icons/scripts/build.mjs. Do not edit. */
export const iconData = {
  "arac": [
    [
      "rect",
      {
        "x": "3.5",
        "y": "4",
        "width": "17",
        "height": "13",
        "rx": "3"
      }
    ],
    [
      "path",
      {
        "d": "M3.5 11h17M8 4v7M7 17v2.5M17 17v2.5"
      }
    ]
  ],
  "sofor": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "8.5"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "2.5"
      }
    ],
    [
      "path",
      {
        "d": "M3.5 12h6M14.5 12h6M12 14.5v6"
      }
    ]
  ],
  "rota": [
    [
      "circle",
      {
        "cx": "6",
        "cy": "19",
        "r": "2.5"
      }
    ],
    [
      "circle",
      {
        "cx": "18",
        "cy": "5",
        "r": "2.5"
      }
    ],
    [
      "path",
      {
        "d": "M8.5 19H15A3.5 3.5 0 0 0 15 12H9A3.5 3.5 0 0 1 9 5h6.5"
      }
    ]
  ],
  "konum": [
    [
      "path",
      {
        "d": "M12 21s7-6.2 7-11.5a7 7 0 0 0-14 0C5 14.8 12 21 12 21z"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "9.5",
        "r": "2.5"
      }
    ]
  ],
  "takvim": [
    [
      "rect",
      {
        "x": "3.5",
        "y": "5",
        "width": "17",
        "height": "15.5",
        "rx": "3"
      }
    ],
    [
      "path",
      {
        "d": "M3.5 10h17M8 3v4M16 3v4"
      }
    ]
  ],
  "yolcu": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "8",
        "r": "3.5"
      }
    ],
    [
      "path",
      {
        "d": "M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7"
      }
    ]
  ],
  "cocuk": [
    [
      "circle",
      {
        "cx": "9",
        "cy": "7.5",
        "r": "2.75"
      }
    ],
    [
      "circle",
      {
        "cx": "17",
        "cy": "11.5",
        "r": "2"
      }
    ],
    [
      "path",
      {
        "d": "M3.5 20c0-3.2 2.5-6 5.5-6s5.5 2.8 5.5 6M14.5 20c0-2 1.1-3.6 2.5-3.6s2.5 1.6 2.5 3.6"
      }
    ]
  ],
  "qr": [
    [
      "rect",
      {
        "x": "3.5",
        "y": "3.5",
        "width": "7",
        "height": "7",
        "rx": "1.5"
      }
    ],
    [
      "rect",
      {
        "x": "13.5",
        "y": "3.5",
        "width": "7",
        "height": "7",
        "rx": "1.5"
      }
    ],
    [
      "rect",
      {
        "x": "3.5",
        "y": "13.5",
        "width": "7",
        "height": "7",
        "rx": "1.5"
      }
    ],
    [
      "path",
      {
        "d": "M14 14h3v3h-3zM20.5 14v2.5M17 20.5h3.5V19"
      }
    ]
  ],
  "nfc": [
    [
      "path",
      {
        "d": "M6.5 9.5c1.3 1.4 1.3 3.6 0 5M10.5 7c2.5 2.7 2.5 7.3 0 10M14.5 4.5c3.7 4 3.7 11 0 15"
      }
    ]
  ],
  "mesaj": [
    [
      "path",
      {
        "d": "M4.5 5h15A1.5 1.5 0 0 1 21 6.5v9a1.5 1.5 0 0 1-1.5 1.5H10l-4.5 3.5V17h-1A1.5 1.5 0 0 1 3 15.5v-9A1.5 1.5 0 0 1 4.5 5z"
      }
    ]
  ],
  "telefon": [
    [
      "path",
      {
        "d": "M6.5 3.5h3l1.5 4-2 1.5a11 11 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16.5 16.5 0 0 1 4.5 5.5a2 2 0 0 1 2-2z"
      }
    ]
  ],
  "uyari": [
    [
      "path",
      {
        "d": "M12 4l9.5 16h-19z"
      }
    ],
    [
      "path",
      {
        "d": "M12 10v4.5M12 17.3v.01"
      }
    ]
  ],
  "rapor": [
    [
      "rect",
      {
        "x": "3.5",
        "y": "3.5",
        "width": "17",
        "height": "17",
        "rx": "3"
      }
    ],
    [
      "path",
      {
        "d": "M8 16v-4M12 16V8M16 16v-6"
      }
    ]
  ],
  "finans": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "8.5"
      }
    ],
    [
      "path",
      {
        "d": "M14.8 9.2c-.6-.9-1.6-1.4-2.8-1.4-1.6 0-2.8.8-2.8 2.1 0 3 5.8 1.4 5.8 4.3 0 1.3-1.2 2.2-2.9 2.2-1.3 0-2.4-.6-3-1.6M12 6.3v1.5M12 16.4v1.4"
      }
    ]
  ],
  "belge": [
    [
      "path",
      {
        "d": "M6.5 3.5H14l4.5 4.5v11a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19V5a1.5 1.5 0 0 1 1.5-1.5z"
      }
    ],
    [
      "path",
      {
        "d": "M14 3.5V8h4.5M8.5 13h7M8.5 16.5h5"
      }
    ]
  ],
  "bakim": [
    [
      "path",
      {
        "d": "M15 4.5a4.5 4.5 0 0 0-4.2 6.1L4.6 16.8a2.1 2.1 0 0 0 3 3l6.2-6.2a4.5 4.5 0 0 0 6.1-4.2l-2.8 2.8-2.6-.7-.7-2.6L16.6 6a4.5 4.5 0 0 0-1.6-1.5z"
      }
    ]
  ],
  "filtre": [
    [
      "path",
      {
        "d": "M3.5 5.5h17l-6.5 7.5V19l-4 1.5V13z"
      }
    ]
  ],
  "bildirim": [
    [
      "path",
      {
        "d": "M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5h-15z"
      }
    ],
    [
      "path",
      {
        "d": "M10 20.5a2 2 0 0 0 4 0"
      }
    ]
  ],
  "destek": [
    [
      "path",
      {
        "d": "M4.5 14v-2a7.5 7.5 0 0 1 15 0v2"
      }
    ],
    [
      "path",
      {
        "d": "M4 13.5h3v5H5.5A1.5 1.5 0 0 1 4 17zM20 13.5h-3v5h1.5A1.5 1.5 0 0 0 20 17zM17.5 18.5c0 1.4-2.2 2-5.5 2"
      }
    ]
  ],
  "profil": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "8.5"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "10",
        "r": "3"
      }
    ],
    [
      "path",
      {
        "d": "M6.6 17.8c1.1-2 3.1-3.3 5.4-3.3s4.3 1.3 5.4 3.3"
      }
    ]
  ],
  "guvenlik": [
    [
      "path",
      {
        "d": "M12 3.5l7.5 3v5.5c0 4.4-3.1 7.4-7.5 8.5-4.4-1.1-7.5-4.1-7.5-8.5V6.5z"
      }
    ],
    [
      "path",
      {
        "d": "M8.8 12.2l2.3 2.3 4.2-4.6"
      }
    ]
  ],
  "check": [
    [
      "path",
      {
        "d": "M5 12.5l4.5 4.5L19 7.5"
      }
    ]
  ],
  "x": [
    [
      "path",
      {
        "d": "M6 6l12 12M18 6L6 18"
      }
    ]
  ],
  "chev-right": [
    [
      "path",
      {
        "d": "M9.5 6l6 6-6 6"
      }
    ]
  ],
  "chev-down": [
    [
      "path",
      {
        "d": "M6 9.5l6 6 6-6"
      }
    ]
  ],
  "arrow-left": [
    [
      "path",
      {
        "d": "M19 12H5.5M11 6l-6 6 6 6"
      }
    ]
  ],
  "plus": [
    [
      "path",
      {
        "d": "M12 5v14M5 12h14"
      }
    ]
  ],
  "search": [
    [
      "circle",
      {
        "cx": "11",
        "cy": "11",
        "r": "6.5"
      }
    ],
    [
      "path",
      {
        "d": "M20 20l-4.3-4.3"
      }
    ]
  ],
  "clock": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "8.5"
      }
    ],
    [
      "path",
      {
        "d": "M12 7.5V12l3 2"
      }
    ]
  ],
  "home": [
    [
      "path",
      {
        "d": "M4 10.5L12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5H15V15h-6v5.5H5.5A1.5 1.5 0 0 1 4 19z"
      }
    ]
  ],
  "list": [
    [
      "path",
      {
        "d": "M8.5 6.5H20M8.5 12H20M8.5 17.5H20M4.5 6.5v.01M4.5 12v.01M4.5 17.5v.01"
      }
    ]
  ],
  "layers": [
    [
      "path",
      {
        "d": "M12 3.5l8.5 4.5-8.5 4.5L3.5 8z"
      }
    ],
    [
      "path",
      {
        "d": "M3.5 12.5l8.5 4.5 8.5-4.5"
      }
    ]
  ],
  "locate": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "6.5"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    ],
    [
      "path",
      {
        "d": "M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3"
      }
    ]
  ],
  "navigation": [
    [
      "path",
      {
        "d": "M12 3l7 17-7-4-7 4z"
      }
    ]
  ],
  "more": [
    [
      "circle",
      {
        "cx": "5.5",
        "cy": "12",
        "r": ".9"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": ".9"
      }
    ],
    [
      "circle",
      {
        "cx": "18.5",
        "cy": "12",
        "r": ".9"
      }
    ]
  ],
  "download": [
    [
      "path",
      {
        "d": "M12 4v11M7 10.5l5 5 5-5M4.5 19.5h15"
      }
    ]
  ],
  "columns": [
    [
      "rect",
      {
        "x": "3.5",
        "y": "4.5",
        "width": "17",
        "height": "15",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M9.5 4.5v15M14.5 4.5v15"
      }
    ]
  ],
  "wifi-off": [
    [
      "path",
      {
        "d": "M3 3l18 18M8.5 16.5a5 5 0 0 1 7 0M5 13a10 10 0 0 1 4.2-2.6M14.8 10.4A10 10 0 0 1 19 13M2 9.5a15 15 0 0 1 4.5-2.8M10.5 5.6A15 15 0 0 1 22 9.5M12 20v.01"
      }
    ]
  ],
  "refresh": [
    [
      "path",
      {
        "d": "M19.5 12a7.5 7.5 0 1 1-2.2-5.3M19.5 4.5v4h-4"
      }
    ]
  ],
  "spark": [
    [
      "path",
      {
        "d": "M12 3.5l1.8 5.2 5.2 1.8-5.2 1.8L12 17.5l-1.8-5.2L5 10.5l5.2-1.8z"
      }
    ],
    [
      "path",
      {
        "d": "M18.5 16.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"
      }
    ]
  ],
  "hand": [
    [
      "path",
      {
        "d": "M8 12V6.5a1.5 1.5 0 0 1 3 0V11M11 10V5a1.5 1.5 0 0 1 3 0v5M14 10V6.5a1.5 1.5 0 0 1 3 0V14c0 3.6-2.4 6.5-6 6.5-2.4 0-4-1.2-5.2-3l-2.1-3.4a1.4 1.4 0 0 1 2.3-1.6L8 14"
      }
    ]
  ],
  "key": [
    [
      "circle",
      {
        "cx": "8",
        "cy": "15",
        "r": "4"
      }
    ],
    [
      "path",
      {
        "d": "M11 12l8.5-8.5M16 7l2.5 2.5M14 9l2 2"
      }
    ]
  ]
} as const;
export type IconName = keyof typeof iconData;
export const iconNames = Object.keys(iconData) as IconName[];
